import React from "react";

import { SvgIcon, SxProps } from "@mui/material";

const ReadLogo = ({
  sx,
  color = "black",
}: {
  sx?: SxProps;
  color?: string;
}) => {
  return (
    <SvgIcon
      sx={{ width: 93, height: 30, ...sx }}
      viewBox="0 0 93 30"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="93"
        height="30"
        viewBox="0 0 93 30"
        fill="none"
      >
        <rect
          x="1.82861"
          y="2.80908"
          width="24.3828"
          height="24.3828"
          rx="3.04785"
          fill="url(#paint0_linear_863_6038)"
        />
        <g clipPath="url(#clip0_863_6038)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.2987 14.9279C21.2987 18.9879 18.0074 22.2791 13.9474 22.2791C9.88745 22.2791 6.59619 18.9879 6.59619 14.9279C6.59619 10.8679 9.88745 7.57666 13.9474 7.57666C18.0074 7.57666 21.2987 10.8679 21.2987 14.9279ZM13.9474 20.5323C17.0427 20.5323 19.5518 18.0231 19.5518 14.9279C19.5518 11.8327 17.0427 9.32349 13.9474 9.32349C10.8522 9.32349 8.34302 11.8327 8.34302 14.9279C8.34302 18.0231 10.8522 20.5323 13.9474 20.5323Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.6387 15.7215C11.9817 16.6661 12.8871 17.3387 13.9474 17.3387C15.0077 17.3387 15.9132 16.6661 16.2562 15.7215L17.8981 16.3178C17.3123 17.931 15.7658 19.0855 13.9474 19.0855C12.129 19.0855 10.5826 17.931 9.99673 16.3178L11.6387 15.7215Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.0265 22.4247V19.5133H23.7733V22.4247C23.7733 23.711 22.7306 24.7538 21.4442 24.7538H18.5328V23.007H21.4442C21.7658 23.007 22.0265 22.7463 22.0265 22.4247Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.01392 7.57666V10.488H4.26709V7.57666C4.26709 6.29033 5.30986 5.24756 6.59619 5.24756H9.50757V6.99439H6.59619C6.27461 6.99439 6.01392 7.25508 6.01392 7.57666Z"
            fill="white"
          />
        </g>
        <path
          d="M42.24 23.8227L38.378 17.1125H36.278V23.8227H33.5264V7.04713H39.3194C40.6067 7.04713 41.6929 7.27241 42.578 7.72298C43.4791 8.17355 44.1469 8.77699 44.5814 9.5333C45.0319 10.2896 45.2572 11.1344 45.2572 12.0677C45.2572 13.162 44.9354 14.1597 44.2917 15.0608C43.6641 15.9458 42.6906 16.5493 41.3711 16.8711L45.5227 23.8227H42.24ZM36.278 14.916H39.3194C40.3492 14.916 41.1217 14.6585 41.6366 14.1436C42.1676 13.6286 42.4331 12.9367 42.4331 12.0677C42.4331 11.1988 42.1757 10.5229 41.6607 10.0402C41.1458 9.54134 40.3653 9.29192 39.3194 9.29192H36.278V14.916Z"
          fill={color}
        />
        <path
          d="M59.7599 16.847C59.7599 17.3458 59.7277 17.7964 59.6634 18.1987H49.5015C49.5819 19.2607 49.9762 20.1136 50.6842 20.7573C51.3922 21.4009 52.2612 21.7228 53.2911 21.7228C54.7715 21.7228 55.8175 21.1032 56.4289 19.8642H59.3979C58.9956 21.0871 58.2634 22.0929 57.2013 22.8814C56.1554 23.6538 54.852 24.04 53.2911 24.04C52.0198 24.04 50.8773 23.7584 49.8635 23.1952C48.8658 22.6159 48.0774 21.8113 47.4981 20.7814C46.9348 19.7354 46.6532 18.5286 46.6532 17.1608C46.6532 15.793 46.9268 14.5941 47.4739 13.5643C48.0371 12.5183 48.8176 11.7137 49.8153 11.1505C50.829 10.5873 51.9876 10.3057 53.2911 10.3057C54.5462 10.3057 55.6646 10.5793 56.6462 11.1264C57.6278 11.6735 58.3921 12.4459 58.9393 13.4436C59.4864 14.4252 59.7599 15.5596 59.7599 16.847ZM56.8876 15.978C56.8715 14.9642 56.5094 14.1516 55.8014 13.5401C55.0933 12.9286 54.2163 12.6229 53.1704 12.6229C52.221 12.6229 51.4083 12.9286 50.7325 13.5401C50.0566 14.1355 49.6543 14.9482 49.5256 15.978H56.8876Z"
          fill={color}
        />
        <path
          d="M61.5506 17.1125C61.5506 15.7769 61.8242 14.5941 62.3713 13.5643C62.9345 12.5344 63.6908 11.7379 64.6402 11.1746C65.6057 10.5953 66.6678 10.3057 67.8264 10.3057C68.8724 10.3057 69.7815 10.5149 70.5539 10.9333C71.3424 11.3356 71.97 11.8425 72.4367 12.4539V10.5229H75.2125V23.8227H72.4367V21.8435C71.97 22.471 71.3344 22.994 70.5298 23.4124C69.7252 23.8308 68.808 24.04 67.7781 24.04C66.6356 24.04 65.5897 23.7503 64.6402 23.171C63.6908 22.5756 62.9345 21.7549 62.3713 20.709C61.8242 19.6469 61.5506 18.4481 61.5506 17.1125ZM72.4367 17.1608C72.4367 16.2435 72.2436 15.447 71.8574 14.7711C71.4873 14.0953 70.9965 13.5804 70.385 13.2263C69.7735 12.8723 69.1137 12.6953 68.4057 12.6953C67.6977 12.6953 67.0379 12.8723 66.4264 13.2263C65.8149 13.5643 65.3161 14.0712 64.9299 14.747C64.5598 15.4068 64.3747 16.1953 64.3747 17.1125C64.3747 18.0297 64.5598 18.8343 64.9299 19.5262C65.3161 20.2182 65.8149 20.7492 66.4264 21.1193C67.054 21.4733 67.7138 21.6504 68.4057 21.6504C69.1137 21.6504 69.7735 21.4733 70.385 21.1193C70.9965 20.7653 71.4873 20.2504 71.8574 19.5745C72.2436 18.8826 72.4367 18.078 72.4367 17.1608Z"
          fill={color}
        />
        <path
          d="M76.944 17.1125C76.944 15.7769 77.2175 14.5941 77.7647 13.5643C78.3279 12.5344 79.0842 11.7379 80.0336 11.1746C80.9991 10.5953 82.0692 10.3057 83.2439 10.3057C84.1128 10.3057 84.9657 10.4988 85.8025 10.885C86.6553 11.2551 87.3312 11.754 87.83 12.3815V5.96094H90.6058V23.8227H87.83V21.8193C87.3795 22.463 86.7519 22.994 85.9473 23.4124C85.1588 23.8308 84.2496 24.04 83.2197 24.04C82.0611 24.04 80.9991 23.7503 80.0336 23.171C79.0842 22.5756 78.3279 21.7549 77.7647 20.709C77.2175 19.6469 76.944 18.4481 76.944 17.1125ZM87.83 17.1608C87.83 16.2435 87.6369 15.447 87.2507 14.7711C86.8806 14.0953 86.3898 13.5804 85.7783 13.2263C85.1668 12.8723 84.5071 12.6953 83.799 12.6953C83.091 12.6953 82.4313 12.8723 81.8198 13.2263C81.2083 13.5643 80.7094 14.0712 80.3232 14.747C79.9531 15.4068 79.7681 16.1953 79.7681 17.1125C79.7681 18.0297 79.9531 18.8343 80.3232 19.5262C80.7094 20.2182 81.2083 20.7492 81.8198 21.1193C82.4473 21.4733 83.1071 21.6504 83.799 21.6504C84.5071 21.6504 85.1668 21.4733 85.7783 21.1193C86.3898 20.7653 86.8806 20.2504 87.2507 19.5745C87.6369 18.8826 87.83 18.078 87.83 17.1608Z"
          fill={color}
        />
        <defs>
          <linearGradient
            id="paint0_linear_863_6038"
            x1="8.00147"
            y1="21.7135"
            x2="22.5077"
            y2="8.82762"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#4361EE" />
            <stop offset="1" stopColor="#7B61FF" />
          </linearGradient>
          <clipPath id="clip0_863_6038">
            <rect
              width="19.5062"
              height="19.5062"
              fill="white"
              transform="translate(4.26709 5.24756)"
            />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
};

export default ReadLogo;
